import {
  CompanyLoanStateTypes,
  CompanyLoanActionTypes,
} from "./CompanyLoan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CompanyLoanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CompanyLoanReducerReducer = (
  state: CompanyLoanStateTypes = INITIAL_STATE,
  action: any
): CompanyLoanStateTypes => {
  switch (action.type) {
    case CompanyLoanActionTypes.FETCH_ALL_COMPANY_LOAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CompanyLoanActionTypes.FETCH_ALL_COMPANY_LOAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CompanyLoanActionTypes.FETCH_ALL_COMPANY_LOAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CompanyLoanActionTypes.FETCH_ALL_COMPANY_LOAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CompanyLoanActionTypes.FETCH_ONE_COMPANY_LOAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CompanyLoanActionTypes.FETCH_ONE_COMPANY_LOAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case CompanyLoanActionTypes.FETCH_ONE_COMPANY_LOAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CompanyLoanActionTypes.FETCH_ONE_COMPANY_LOAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CompanyLoanReducerReducer;
